import { render, staticRenderFns } from "./drag-modal.vue?vue&type=template&id=af051c3c&scoped=true&"
import script from "./drag-modal.vue?vue&type=script&lang=js&"
export * from "./drag-modal.vue?vue&type=script&lang=js&"
import style0 from "./drag-modal.vue?vue&type=style&index=0&id=af051c3c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af051c3c",
  null
  
)

export default component.exports